import script from "./PrintGoodLabelBtn.vue?vue&type=script&lang=ts&setup=true"
export * from "./PrintGoodLabelBtn.vue?vue&type=script&lang=ts&setup=true"

import "./PrintGoodLabelBtn.vue?vue&type=style&index=0&id=f3f13988&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f3f13988"]])

export default __exports__